module.exports = __webpack_public_path__ + "static/media/021_intel3_9.54927648.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/intel/021_intel3_9.png
// module id = 491
// module chunks = 0